<template>
  <div class="wrapper hefei-bg-f5" style="display: flex;flex-direction:column;">
    <div class="container-wrap-form">
      <SearchInputWithHistory
        placeholder='搜索医院'
        inputColor='white'
        cookieName='search_history_hosp'
        resultItemName='name'
        :injectFocus="isFocus"
        :result='result'
        @on-search='search'
        @on-search-result='searchResult'
        @on-load-more='loadList'
      />
    </div>
  </div>
</template>

<script>
import SearchInputWithHistory from '@/components/common/SearchInputWithHistory'

export default {
  components: {
    SearchInputWithHistory: SearchInputWithHistory
  },
  data () {
    return {
      pageNo: 1,
      rows: 20,
      selectType: '',
      isFocus: true,
      phospId: '',
      content: '',
      result: [],
      allLoaded: false,
      timer: null,
      initHistory: {
        name: '所有医院',
        phospId: ''
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList (clearable) {
      this.$http.getHosps(
        {
          content: this.content
        },
        {
          pageNo: this.pageNo,
          rows: this.rows
        }
      ).then(res => {
        if (res) {
          this.result = clearable ? res : [...this.result, ...res]
          this.pageNo++
        }
        if (this.content === '' && this.result[0].phospId !== '') {
          this.result.unshift(this.initHistory)
        }
        if (res.length < this.rows) {
          // if all data are loaded
          this.allLoaded = true
        }
      })
    },
    loadList () {
      if (this.allLoaded) {
        return false
      }
      this.getList(false)
    },
    search (data) {
      this.pageNo = 1
      this.content = data
      this.allLoaded = false

      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getList(true)
      }, 1000)
    },
    searchResult (hosp) {
      let searchKey = this.$store.getters.searchKey

      if (hosp.name !== searchKey.hosp.name) {
        searchKey.dept = {deptName: '所有科室', phospDeptId: ''}
      }
      searchKey.hosp = hosp
      this.$store.commit('setSearchKey', searchKey)
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/hospsFilter.vue